import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { SentryService } from 'utils/SentryService';

export class LocalStorage {
  private static storage = typeof window !== 'undefined' ? window.localStorage : undefined;

  public static getItem(key: LocalStorageKey) {
    try {
      return this.storage?.getItem(key);
    } catch {
      return undefined;
    }
  }

  public static setItem(key: LocalStorageKey, value: string) {
    try {
      this.storage?.setItem(key, value);
    } catch (e) {
      SentryService.captureException(e);
    }
  }

  public static removeItem(key: LocalStorageKey) {
    try {
      this.storage?.removeItem(key);
    } catch (e) {
      SentryService.captureException(e);
    }
  }
}
